import { difference, keys } from "lodash-es";

const defaultState = () => {
	return {
		companies: {
			count: 0,
			results: [],
		},
		company: {
			id: null,
			group_id: null,
			name: null,
			email_domain: null,
			role_id: null,
			role_value: null,
			status: "Active",
			default_report_id: null,
			fcp_role: null,
			filevine_id: null,
		},
	};
};

const state = {
	companies: defaultState().companies,
	company: defaultState().company,
};

const getters = {
	companies: (state) => {
		return state.companies;
	},
	company: (state) => {
		return state.company;
	},
};

const actions = {};

const mutations = {
	GET_COMPANIES: (state, payload) => {
		if (payload) {
			state.companies.count += payload.count;
			state.companies.results = state.companies.results.concat(
				payload.results
			);
		} else {
			state.companies = defaultState().companies;
		}
	},
	CREATE_COMPANY: (state, payload) => {
		state.companies.count += 1;
		state.companies.results.push(payload.data);
	},
	READ_COMPANY: (state, payload) => {
		if (payload) {
			payload.data.role_id = payload.data.role
				? payload.data.role.id
				: null;

			state.company = payload.data;
		} else {
			state.company = defaultState().company;
		}
	},
	UPDATE_COMPANY: (state, payload) => {
		const index = state.companies.results.findIndex(
			(item) => item.id == payload.data.id
		);

		if (0 <= index) {
			const diff = difference(
				keys(state.companies.results[index]),
				keys(payload.data)
			);

			if (0 < diff.length)
				diff.forEach((item) => {
					payload.data[item] = state.companies.results[index][item];
				});

			state.companies.results.splice(index, 1, payload.data);
		}
	},
	DELETE_COMPANY: (state, payload) => {
		const index = state.companies.results.findIndex(
			(item) => item.id == payload.data.id
		);

		if (0 <= index) {
			state.companies.count -= 1;
			state.companies.results.splice(index, 1);
		}

		state.company =
			state.company.id == payload.data.id
				? defaultState().company
				: state.company;
	},
	UPDATE_COMPANY_DATA: (state, payload) => {
		if (!payload.key && !payload.value) return false;

		state.company[payload.key] = payload.value;
	},
};

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations,
};
